import media from "../customMedia.json";
import { isSiteCoreMedia } from "../CategoryHeaderVideo/generatePosterUrl";

// Preset/width pairs supported by the media CDN, mirroring ProductImage.
const srcSetList = [
  [480, 476],
  [640, 634],
  [750, 714],
  [960, 952],
  [1280, 1268],
  [1440, 1428],
  [1920, 1904],
];

const FALLBACK_WIDTH = 476;
const FALLBACK_PRESET = 480;

// The desktop asset is only wide enough to look right once the layout is wide
// enough for it. Below this the portrait mobile asset crops far less.
const [DESKTOP_MEDIA_QUERY] = media.customMedia["--large-viewport"].match(
  /(\(min-width: [^)]+\))/,
);

export { DESKTOP_MEDIA_QUERY };

const buildSrcSet = (imageUrl) =>
  srcSetList
    .map(
      ([preset, width]) =>
        `${imageUrl}?$n_${preset}w$&wid=${width}&fit=constrain ${width}w`,
    )
    .join(", ");

const buildSource = (imageUrl) => {
  if (typeof imageUrl !== "string" || !imageUrl) {
    return undefined;
  }

  // Sitecore serves a single fixed asset, so there is nothing to resize.
  if (isSiteCoreMedia(imageUrl)) {
    return { src: imageUrl };
  }

  return {
    src: `${imageUrl}?$n_${FALLBACK_PRESET}w$&wid=${FALLBACK_WIDTH}&fit=constrain`,
    srcSet: buildSrcSet(imageUrl),
  };
};

export const generateImageSources = (featuredHeaderData) => ({
  mobile: buildSource(featuredHeaderData?.app?.imageUrl),
  desktop: buildSource(featuredHeaderData?.web?.imageUrl),
});
